// extracted by mini-css-extract-plugin
export default {"head":"users-list_head__pHEp+"};